import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../helpers/connectRedux'

import { Page, Spinner } from '../../components'
import { LiteralsService, StorageService } from '../../services'
import { checkSessionAction, setChangeLanguageAction } from '../../store/actions'
import { AnyAction } from 'redux'

type Props = DispatchProp<AnyAction>

class Splash extends PureComponent<Props> {
  public async componentDidMount() {
    const { dispatch } = this.props
    const language = await StorageService.getLanguage()

    if (language) {
      LiteralsService.setLanguage(language)
      dispatch(setChangeLanguageAction(language))
    }
    setTimeout(() => {
      dispatch(checkSessionAction())
    }, 1000)
  }

  public render(): ReactNode {
    return (
      <Page style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </Page>
    )
  }
}

export default connectRedux(null, Splash)
